import { render, staticRenderFns } from "./rgTemplateModal.vue?vue&type=template&id=dd4a1d48&"
import script from "./rgTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./rgTemplateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports